import React from 'react'
import { Script, ScriptStrategy } from 'gatsby';

export default function Chatbot() {

    return null;
/*
    return (
        <Script id="chatbot">
                {`
                var BMB_MESSENGER_domain = 'https://messenger.myma.ai/';
var BMB_messengerHTMLPath = BMB_MESSENGER_domain + 'index.html';
var BMB_MESSENGER_head = document.getElementsByTagName('head')[0];
var BMB_MESSENGER_script = document.createElement('script');
BMB_MESSENGER_script.type = 'text/javascript';
BMB_MESSENGER_script.src = BMB_MESSENGER_domain + 'msgplugin.js';
BMB_MESSENGER_head.appendChild(BMB_MESSENGER_script);
var BMB_MESSENGER_gid = '${process.env.GATSBY_CHATBOT_CODE}';
var BMB_MESSENGER_iid = window.chatbot_code;
var BMB_MESSENGER_pid = '';
                `}
                </Script>
    )*/
}